<template>
    <div class="w-100">
        <c-column-header
            v-if="title"
            :label = "title"
            class  = "primary"
        />
        <div
            @dragover.prevent
            @drop.prevent
            class      = "upload-panel lm-border mt-1"
            :style     = "minImageHightStype"
            @drop      = "onDrop"
            @dragleave = "fileDragOut"
            @dragover  = "fileDragIn"
            :class     = "drag ? 'drop-allowed':''"
        >
            <div>
                <img
                    v-if  = "image"
                    :src  = "image"
                    alt   = ""
                    class = "upload-image"
                />
            </div>
        </div>
        <slot name="additional" />
    </div>
</template>

<script>

import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";

export default {
    name: "FImageUpload",
    components: {
        CColumnHeader,
    },

    props: {
        title: {

        },

        image: {

        },

        minImageHeight: {
            required: false,
            default: function () {
                return 80;
            }
        },
    },

    data: () => ({
        drag: false,
        preview: {
            show: false,
            image: null
        }
    }),

    computed: {
        minImageHightStype () {
            return 'min-height:' + this.minImageHeight + 'px';
        },
    },

    methods: {
        fileDragIn(){
            console.log("fileDragIn")
            this.drag = true;
        },

        fileDragOut() {
            console.log("fileDragOut")
            this.drag = false;
        },

        onDrop(e) {
            console.log("onDrop", e)
            this.drag = false;
            let droppedFiles = e.dataTransfer.files;

            if(!droppedFiles) {
                return;
            }

            if (this.stamp) {
                this.$emit("drop", {
                    id  : this.stamp.id,
                    file: droppedFiles[0]
                });
                return;
            }

            this.$emit("drop", droppedFiles[0]);
        },
    }
}
</script>

<style scoped>

.upload-panel {
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: calc(100% - 30px)
}

.upload-image {
    max-width: 100%;
    max-height: 100%
}

</style>